export default "__VITE_ASSET__28fcaea4__"